import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GeaoContext } from "../../GeaoContextProvider";
import { GeaoPaths } from "../../constants/GeaoPaths";

export default function useCreateYourProfileNationalAccountNavigation({
    duplicateAgency,
    duplicateAgent,
    niprAgencyNameChange,
    niprAgentNameChange,
    niprNameChangeAccepted,
    agencyAssessmentKickout,
    agentAssessmentKickout,
    parentAgencyMustOnboard,
    agencyOffshoreMustBeApproved
}) {
    const { agentInterview } = useContext(GeaoContext);
    const navigate = useNavigate();

    /**
     * Navigate to the recall flow if a duplicate interview was found.
     */
    useEffect(() => {
        if (duplicateAgency || duplicateAgent) {
            navigate(GeaoPaths.ApplicationStatus);
        }
    }, [duplicateAgency, duplicateAgent, navigate]);

    /**
     * Navigate to the assessment kickout page.
     */
    useEffect(() => {
        if (agencyAssessmentKickout || agentAssessmentKickout) {
            navigate(GeaoPaths.CreateYourProfileKickout);
        }
    }, [agencyAssessmentKickout, agentAssessmentKickout, navigate]);

    /**
     * Navigate to the Welcome Checklist on success, matching the standard CreateYourProfile flow.
     */
    useEffect(() => {
        if (agentInterview?.status !== "Active") return;
        if (duplicateAgency || duplicateAgent) return;
        if ((niprAgencyNameChange || niprAgentNameChange) && !niprNameChangeAccepted) return;
        if (agencyAssessmentKickout || agentAssessmentKickout) return;
        if (parentAgencyMustOnboard) return;
        if (agencyOffshoreMustBeApproved) return;

        navigate(GeaoPaths.PrincipalWelcomeChecklist);
    }, [
        duplicateAgency,
        duplicateAgent,
        niprAgencyNameChange,
        niprAgentNameChange,
        niprNameChangeAccepted,
        agencyAssessmentKickout,
        agentAssessmentKickout,
        parentAgencyMustOnboard,
        agencyOffshoreMustBeApproved,
        navigate,
        agentInterview
    ]);
}
